(function () {
  document.addEventListener('DOMContentLoaded', function () {
    function relocateProductRating() {
      var productPage = document.querySelector('[data-product-section]');
      var buybox = document.querySelector('.fh-product-buybox');
      var title = document.querySelector('.fh-product-buybox__title');

      if (!productPage || !buybox || !title) return;

      var existingTarget = buybox.querySelector('.fh-product-buybox__rating');
      if (!existingTarget) {
        existingTarget = document.createElement('div');
        existingTarget.className = 'fh-product-buybox__rating';
        existingTarget.setAttribute('data-fh-product-rating', '');
        title.insertAdjacentElement('afterend', existingTarget);
      }

      var appBadges = Array.prototype.slice.call(document.querySelectorAll('.shopify-section .jdgm-preview-badge, .shopify-section .jdgm-widget.jdgm-preview-badge'));
      var sourceBadge = appBadges.find(function (badge) {
        if (badge.closest('.fh-product-card')) return false;
        if (badge.closest('.fh-product-buybox')) return false;
        if (badge.closest('.jdgm-rev-widg')) return false;
        return true;
      });

      if (sourceBadge) {
        var sourceSection = sourceBadge.closest('.shopify-section');
        existingTarget.appendChild(sourceBadge);
        if (sourceSection) sourceSection.classList.add('fh-judgeme-app-relocate-source');
        return;
      }

      var metafieldBadge = productPage.querySelector('.fh-judgeme-preview-badge, .jdgm-preview-badge');
      if (metafieldBadge && !metafieldBadge.closest('.fh-product-card') && !metafieldBadge.closest('.fh-product-buybox')) {
        existingTarget.appendChild(metafieldBadge);
      }
    }

    function relocateDesktopCollectionSort() {
      if (!window.matchMedia || !window.matchMedia('(min-width: 1024px)').matches) return;

      var sidebar = document.querySelector('.fh-collection-sidebar');
      var results = document.querySelector('.fh-collection-results');
      if (!sidebar || !results) return;

      var sortForm = sidebar.querySelector('.fh-collection-sort');
      if (!sortForm) return;

      var toolbar = results.querySelector('.fh-collection-toolbar');
      if (!toolbar) {
        toolbar = document.createElement('div');
        toolbar.className = 'fh-collection-toolbar';
        toolbar.setAttribute('aria-label', 'Collection sorting');

        var sidebarCount = sidebar.querySelector('.fh-collection-sidebar__meta span');
        if (sidebarCount) {
          var toolbarCount = document.createElement('span');
          toolbarCount.className = 'fh-collection-toolbar__count';
          toolbarCount.textContent = sidebarCount.textContent;
          toolbar.appendChild(toolbarCount);
        }

        results.insertBefore(toolbar, results.firstElementChild);
      }

      sortForm.classList.add('fh-collection-sort--toolbar');
      toolbar.appendChild(sortForm);
    }

    relocateProductRating();
    relocateDesktopCollectionSort();
  });
})();
